export default __webpack_public_path__ + "static/media/staff1.53270f98.jpeg";